import { render, staticRenderFns } from "./baseBuilding.vue?vue&type=template&id=e94fb4da&"
import script from "./baseBuilding.vue?vue&type=script&lang=js&"
export * from "./baseBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports